import { type Dispatch } from 'react';
import { ALL_OFFERS } from '../AvailabilityPresentation.utils';
import {
  type OfferIdChangeAction,
  type SelectionAction,
  SelectionActionType,
  type SelectionState,
  type TravellersSelectionChangeAction,
} from './selectionReducer.interfaces';

export const initialState: SelectionState = {
  offerId: ALL_OFFERS,
  travellersSelection: {
    rooms: [{ adults: 2, children: [] }],
  },
};

export const selectionReducer = (
  state: SelectionState,
  { type, payload }: SelectionAction
): SelectionState => {
  switch (type) {
    case SelectionActionType.OfferIdChange: {
      return {
        ...state,
        offerId: payload,
      };
    }
    case SelectionActionType.TravellersSelectionChange: {
      return {
        ...state,
        travellersSelection: payload,
      };
    }
    default: {
      return state;
    }
  }
};

export const selectionActions = (dispatch: Dispatch<SelectionAction>) => {
  return {
    changeOfferId: (offerId: OfferIdChangeAction['payload']) =>
      dispatch({ type: SelectionActionType.OfferIdChange, payload: offerId }),
    changeTravellersSelection: (travellersSelection: TravellersSelectionChangeAction['payload']) =>
      dispatch({
        type: SelectionActionType.TravellersSelectionChange,
        payload: travellersSelection,
      }),
  };
};
